<template>
  <div class="form__group">
    <input type="hidden" v-model="value" :id="identifier" :name="identifier" />

    <div class="form__field" v-show="currentAction.title">
      <div class="form__title">
        {{ currentAction.title }}
      </div>
    </div>

    <div class="form__breaker"></div>

    <template v-show="completedFields.length > 0">
      <div
        class="form__field"
        v-for="completedField in completedFields"
        :key="completedField.name"
      >
        <span class="form__block">
          {{ completedField.label }}:
          <strong>{{ completedField.value }}</strong>
        </span>
      </div>
    </template>

    <div
      class="form__field"
      v-show="currentAction.cancel"
      style="display: flex; align-items: center; justify-content: center"
      v-bind:class="{ 'checkmark-container': field.isVoucher }"
    >
      <span v-if="field.isVoucher" class="checkmark">
        <div class="checkmark_circle"></div>
        <div class="checkmark_stem"></div>
        <div class="checkmark_kick"></div>
      </span>
      <a
        v-else
        class="button button--secondary"
        @click="cancel()"
        v-show="currentAction.cancel"
      >
        <span class="button__icon icon-cancel"></span>
      </a>
    </div>

    <div class="form__breaker"></div>

    <component
      v-for="currentField in currentFields"
      :key="currentField.name"
      :field="currentField"
      :is="'checkout-field-' + currentField.type"
      :process-value="value"
      :process-field="field"
    >
    </component>
    <div class="form__breaker"></div>
    <div class="form__text" v-show="field.error">
      <div class="form__message form__message--error">
        {{ field.error }}
      </div>
    </div>
  </div>
</template>

<script>
import * as Components from ".";
import axios from "axios";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-process",
  watch: {
    currentAction() {
      if (this.field.isVoucher && this.field.emitChange) {
        const succeed = Boolean(this.currentAction.cancel);
        window.dispatchEvent(
          new CustomEvent("onVoucherStateChange", {
            detail: { succeed }
          })
        );
      }
    }
  },
  computed: {
    completedFields: function() {
      return this.field.fields
        .filter(
          field =>
            this.currentAction.fieldInfos &&
            this.currentAction.fieldInfos.includes(field.name)
        )
        .filter(field => !field.disabled)
        .filter(field => field.value)
        .map(field => {
          switch (field.type) {
            case "password":
              field.value = "*".repeat(field.value.length);
              break;
          }

          if (field.data && field.data.infoLabel) {
            field.label = field.data.infoLabel;
          }

          return field;
        });
    },
    currentAction: function() {
      return this.field.actions.find(
        action => action.name === this.field.value
      );
    },
    currentFields: function() {
      return this.field.fields
        .filter(field => this.currentAction.fieldNames.includes(field.name))
        .filter(field => !field.disabled);
    }
  },
  methods: {
    cancel: function() {
      let action = this.field.actions.find(
        action => (action.name = this.currentAction.cancel)
      );

      this.field.actions
        .slice(this.field.actions.indexOf(action))
        .forEach(action => {
          this.field.fields
            .filter(field => action.fieldNames.includes(field.name))
            .forEach(field => (field.value = null));
        });

      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: {
          value: this.currentAction.cancel
        }
      });
    },
    submit: function() {
      this.$store.dispatch("runFieldAction", {
        field: this.field,
        action: this.currentAction
      });
    }
  }
};
</script>

<style>
.checkmark-container {
  margin-left: 0;
}
.checkmark {
  display: inline-block;
  width: 22px;
  height: 22px;
  -ms-transform: rotate(45deg); /* IE 9 */
  -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
  transform: rotate(45deg);
}

.checkmark_circle {
  position: absolute;
  width: 22px;
  height: 22px;
  background-color: green;
  border-radius: 11px;
  left: 0;
  top: 0;
}

.checkmark_stem {
  position: absolute;
  width: 3px;
  height: 9px;
  background-color: #fff;
  left: 11px;
  top: 6px;
}

.checkmark_kick {
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #fff;
  left: 8px;
  top: 12px;
}
</style>
